import { useEffect, useMemo, useRef, useState } from 'react';
import _, { isEqual } from 'lodash';
import {
  Box,
  Checkbox,
  DialogContent,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  Radio,
  RadioGroup,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';

import { ehrAPIBaseService, ehrAPIService } from '../../../../http-common';
import FHIRHumanName from '../../molecule/fhirHumanName';
import FHIRAddress from '../../molecule/fhirAddress';
import { paperWithTopLabelAndBottomValue } from '../../uiComponent';
import { useSnackbar } from 'notistack';
import { generateNotifications } from '../../../reusableLogic';
import FHIRTelecom from '../../molecule/fhirTelecom';
import { patientGenderOptionsList } from '../../../../data/fhirHumanNameData';
import {
  AutoCompleteWithTopLabel,
  DateSelectorWithTopLabelComponent,
  SelectWithTopLabelComponent,
  TextFieldWithTopLabelComponent,
} from '../../uiComponent/fhirComponentUi';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import {
  ACTION_CLOSE_ALL_DRAWER,
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
  ACTION_OPEN_TOOLBAR,
  ACTION_RIGHT_DRAWER,
  ACTION_RIGHT_DRAWER_JSX,
  ACTION_RIGHT_DRAWER_NOT,
  ACTION_SET_TOOLBAR_JSX,
} from '../../../MainUIFrame/constants';
import AddLicenseDrawer from '../../../../pages/account/pages/AddLicense';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import {
  useMainFrameDispatch,
  useMainFrameState,
} from '../../../MainUIFrame/MainFrame';
import { setEditMode } from '../../../../redux/features/editModeSlice';
import moment from 'moment';

import { setProgress } from '../../../../redux/features/progressSlice';

import { languageList } from '../../../../data/valueSets/languages2';
import { flatObjectFromFhirPractitioner } from '../../../reusableLogic/fhirComplexObjectFlatning';
import { setReduxCurrentPractitionerObject } from '../../../../redux/features/currentSlice';
import { AddCircle, Delete } from '@mui/icons-material';
import { forwardRef } from 'react';
import { useImperativeHandle } from 'react';
import NPIRegistryDrawer from '../../../NPI/NPIRegistryDrawer';
import { useNavigate } from 'react-router-dom';
import { useConfirm } from 'material-ui-confirm';
import {
  resetStateDetectorState,
  setStateDetectorState,
} from '../../../../redux/features/stateDetectorSlice';
import Prompt from '../../../BlockerConfirm/blockerConfirm';
import CustomConfirmDialog from '../../../customConfirmationDialog';

const practitionerInitailStateFromProps = (data, selectedVersion) => {
  debugger;
  let qualificationFind =
    data?.qualification &&
    data?.qualification.find(
      f =>
        f?.code?.coding?.[0]?.system ===
        'http://terminology.hl7.org/CodeSystem/v2-0360/2.7'
    );

  let version1Value;
  let version1Name;

  if (selectedVersion === 'IN') {
    version1Value =
      data?.identifier?.[
        _.findIndex(
          data?.identifier,
          o => o?.type?.coding?.[0].code === 'AADHAAR'
        )
      ]?.value;
    version1Name = 'aadhaar';
  } else if (
    _.isUndefined(
      data?.identifier?.find(o => o?.type?.coding?.[0].code === 'SS')
    )
  ) {
    version1Value =
      data?.identifier?.[
        _.findIndex(
          data?.identifier,
          o => o?.type?.coding?.[0].code === 'AADHAAR'
        )
      ]?.value;
    version1Name = 'aadhaar';
  } else {
    version1Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'SS')
      ]?.value;
    version1Name = 'ssn';
  }

  let version2Value;
  let version2Name;

  if (selectedVersion === 'IN') {
    version2Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'NMC')
      ]?.value;
    version2Name = 'nmc';
  } else if (
    _.isUndefined(
      data?.identifier?.find(o => o?.type?.coding?.[0].code === 'NPI')
    )
  ) {
    version2Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'NMC')
      ]?.value;
    version2Name = 'nmc';
  } else {
    version2Value =
      data?.identifier?.[
        _.findIndex(data?.identifier, o => o?.type?.coding?.[0].code === 'NPI')
      ]?.value;
    version2Name = 'npi';
  }

  return {
    id: data?.id,
    resourceType: data?.resourceType,
    name: data?.name,
    gender: !_.isUndefined(data?.gender) ? data?.gender : '',
    birthDate: !_.isUndefined(data?.birthDate) ? data?.birthDate : '',
    telecom: data?.telecom,
    address: data?.address,
    identifier: data?.identifier,
    qualificationObject: {
      code: !_.isUndefined(qualificationFind)
        ? qualificationFind?.code?.coding?.[0]?.code
        : '',
      display: !_.isUndefined(qualificationFind)
        ? qualificationFind?.code?.coding?.[0]?.display
        : '',
    },
    languageObject: {
      code: data?.communication?.[0]?.coding?.[0]?.code,
      display: data?.communication?.[0]?.coding?.[0]?.display,
    },
    managingOrganizationObject: {
      code: data?.managingOrganization?.reference,
    },
    primaryCareObject: {
      code: data?.generalPractitioner?.[0]?.reference,
    },
    generalPractitionerObject: {
      code: data?.generalPractitioner?.[1]?.reference,
    },

    [version1Name]: version1Value,
    [version2Name]: version2Value,
    active: !_.isUndefined(data?.active) ? data?.active : true,
  };
};

const qualificationSelectList = [
  {
    code: 'BS',
    display: 'Bachelor of Science',
  },
  {
    code: 'MS',
    display: 'Master of Science',
  },
  {
    code: 'MBBS',
    display: 'Bachelor of Medicine and Bachelor of Surgery',
  },
  {
    code: 'MD',
    display: 'Doctor of Medicine',
  },
  {
    code: 'DO',
    display: 'Doctor of Osteopathic Medicine',
  },
];

const FHIRPractitioner = forwardRef((props, ref) => {
  const selectedVersion = useSelector(
    state => state.changeVersion.selectedVersion
  );
  const confirmation = CustomConfirmDialog;
  const { isCreate } = props;
  const setIsCreatePatient = props?.setIsCreatePatient;
  const addressRef = useRef();
  const humanNameRef = useRef();
  const telecomRef = useRef();
  const languageRef = useRef();
  const editMode = useSelector(state => {
    return state?.edit?.editMode;
  });
  const isEdit = editMode;
  const practitionerObject = props?.practitionerObject;
  const { isDark } = useMainFrameState();

  const [isECSEnabled, setIsECSEnabled] = useState('no');
  const [licenses, setLicenses] = useState([]);
  const [licensesBackup, setLicensesBackup] = useState([]);

  const [practitionerState, setPractitionerState] = useState(
    practitionerInitailStateFromProps(practitionerObject, selectedVersion)
  );
  const [isMyPractice, setIsMyPractice] = useState(props?.isMyPractice);
  const [initialState, setInitialState] = useState();
  const [isStateChanged, setIsStateChanged] = useState(false);
  const [flattenedInitialState, setFlattenedInitialState] = useState();
  const [flattenedPractitionerState, setFlattenedPractitionerState] =
    useState();
  const [flattenedLicenseState, setFlattenedLicenseState] = useState();
  const [flattenedLicenseBackupState, setFlattenedLicenseBackupState] =
    useState();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const dispatch = useMainFrameDispatch();
  const isPatientStateChanged = useSelector(
    state => state?.stateDetector?.isPatientStateChanged
  );

  const genderRef = useRef(null);
  const birthDateRef = useRef(null);
  const ssnRef = useRef(null);
  const aadhaarRef = useRef(null);
  const primaryCareRef = useRef(null);
  const managingOrganizationRef = useRef(null);
  const generalPractitionerRef = useRef(null);
  const activeRef = useRef(null);
  const qualificationRef = useRef(null);
  const nmcRef = useRef(null);
  const npiRef = useRef(null);
  const nameRef = useRef(null);
  const addRef = useRef(null);
  const contactRef = useRef(null);
  const v1Ref = useRef(null);
  const v2Ref = useRef(null);

  const reduxDispatch = useDispatch();

  useEffect(() => {
    setInitialState(practitionerState);
  }, []);

  useEffect(() => {
    console.log(practitionerState);
  }, [practitionerState]);

  function flattenObject(obj) {
    const flattenArray = [];

    function flatten(obj) {
      if (typeof obj === 'object' && obj !== null) {
        if (Array.isArray(obj)) {
          for (let i = 0; i < obj.length; i++) {
            flatten(obj[i]);
          }
        } else {
          for (let key in obj) {
            flatten(obj[key]);
          }
        }
      } else {
        flattenArray.push(obj);
      }
    }

    flatten(obj);
    return flattenArray;
  }

  function deepEqual(arr1, arr2) {
    if (arr1 !== null && arr2 !== null) {
      if (arr1.length !== arr2.length) {
        return false;
      }

      const replacedArr1 = arr1.map((value, index) =>
        value === null ? undefined : arr1[index]
      );
      const replacedArr2 = arr2.map((value, index) =>
        value === null ? undefined : arr2[index]
      );

      for (let i = 0; i < replacedArr1.length; i++) {
        const value1 = replacedArr1[i];
        const value2 = replacedArr2[i];

        if (typeof value1 === 'object' && typeof value2 === 'object') {
          if (!deepEqual(value1, value2)) {
            return false;
          }
        } else if (value1 !== value2) {
          return false;
        }
      }

      return true;
    }

    return false;
  }

  useEffect(() => {
    setFlattenedInitialState(flattenObject(initialState));
    setFlattenedPractitionerState(flattenObject(practitionerState));
    setFlattenedLicenseState(flattenObject(licenses));
    setFlattenedLicenseBackupState(flattenObject(licensesBackup));
  }, [initialState, practitionerState, licenses, licensesBackup]);

  useEffect(() => {
    debugger;
    if (
      !_.isUndefined(flattenedInitialState) &&
      flattenedInitialState !== null &&
      !_.isUndefined(flattenedPractitionerState) &&
      flattenedPractitionerState !== null &&
      !_.isUndefined(flattenedLicenseState) &&
      flattenedLicenseState !== null &&
      !_.isUndefined(flattenedLicenseBackupState) &&
      flattenedLicenseBackupState !== null
    ) {
      const flag =
        !deepEqual(flattenedPractitionerState, flattenedInitialState) ||
        !deepEqual(flattenedLicenseState, flattenedLicenseBackupState);
      setIsStateChanged(flag);
      reduxDispatch(setStateDetectorState({ isBasePatientStateChanged: flag }));
    }
  }, [
    JSON.stringify(flattenedInitialState),
    JSON.stringify(flattenedPractitionerState),
    JSON.stringify(flattenedLicenseState),
    JSON.stringify(flattenedLicenseBackupState),
  ]);

  const genderValidationObject = {
    name: 'gender',
    value: practitionerState?.gender,
    label: 'Gender',
    ref: genderRef,
    width: '90%',
    optionsList: patientGenderOptionsList,
    validation: {
      required: false,
    },
  };

  const birthDateValidationObject = {
    name: 'birthDate',
    value: practitionerState?.birthDate,
    label: 'Birth Date',
    format: 'MM/dd/yyyy',
    // format: 'dd/MM/yyyy',
    ref: birthDateRef,
    width: '90%',
    validation: { required: false },
  };

  const qualificationValidationObject = {
    name: 'qualificationObject',
    value: practitionerState?.qualificationObject,
    label: 'Qualification',
    optionsList: qualificationSelectList,
    width: '98.3%',
    ref: qualificationRef,
    validation: {
      required: false,
    },
    zIndex: 1000,
  };

  const ValidationObject1 = (practitionerState, selectedVersion) => {
    if (selectedVersion === 'IN') {
      return {
        name: 'aadhaar',
        value: practitionerState?.aadhaar,
        label: 'AADHAAR',
        ref: aadhaarRef,
        width: '95%',
        validation: {
          required: false,
          min: 12,
          max: 12,
        },
        mask: '9999-9999-9999',
        maxLength: 12,
      };
    } else {
      return {
        name: 'ssn',
        value: practitionerState?.ssn,
        label: 'SSN',
        ref: ssnRef,
        width: '95%',
        validation: {
          required: false,
          min: 4,
          max: 9,
        },
        //mask: '999-99-9999',
        mask: practitionerState?.ssn?.length > 4 ? '999-99-9999' : '(9999)',
        maxLength: 9,
      };
    }
  };

  const ValidationObject2 = (practitionerState, selectedVersion) => {
    let name;
    let value;
    let ref;
    let label;
    let validation;
    let mask;
    let maxLength;
    let width;

    if (selectedVersion === 'IN') {
      name = 'nmc';
      value = practitionerState?.nmc;
      label = 'NMC';
      ref = nmcRef;
      width = '95%';
      validation = {
        required: true,
        // min: 10,
        // max: 10,
      };
      // maxLength= 10;
    } else {
      name = 'npi';
      value = practitionerState?.npi;
      label = 'NPI';
      ref = npiRef;
      width = '95%';
      validation = {
        required: true,
        min: 10,
        max: 10,
      };
      maxLength = 10;
    }

    return {
      name,
      value,
      label,
      ref,
      width: '95%',
      validation,
      mask,
      maxLength,
    };
  };

  const activeValidationObject = {
    name: 'active',
    value: practitionerState?.active,
    label: 'Status',
    optionsList: [
      { code: true, display: 'Active' },
      { code: false, display: 'Inactive' },
    ],
    ref: activeRef,
  };

  const [primaryCareOptionsList, setPrimaryCareOptionsList] = useState([]);
  const [generalPractitionerOptionsList, setGeneralPractitionerOptionsList] =
    useState([]);
  const [managingOrganizationOptionsList, setManagingOrganizationOptionsList] =
    useState([]);

  const [optionsListRetrieved, setOptionsListRetrieved] = useState(false);
  const getOrganizationData = async (type, searchText) => {
    try {
      let searchQuery = `search/?_elements=name,type&_sort=name&_type=Organization,Practitioner`;
      if (searchText && !_.isEmpty(searchText)) {
        searchQuery += `&_content:contains=${searchText}`;
      }
      const response = await ehrAPIService.get(searchQuery);

      let organizationProvArray = [];
      let gpArray = [];
      let organizationNotProvAndInsArray = [];

      for (let item of response?.data?.entry) {
        if (item?.resource?.resourceType?.toLowerCase() === 'organization') {
          if (item?.resource?.type?.[0]?.coding?.[0]?.code === 'prov') {
            organizationProvArray.push(item?.resource);
          }
          organizationNotProvAndInsArray.push(item?.resource);
        } else {
          organizationProvArray.push(item?.resource);
          gpArray.push(item?.resource);
        }
      }

      for (let type_ of type) {
        switch (type_) {
          case 'gp':
            let optionsArrayGP = [];
            for (let item of gpArray) {
              let obj = {
                display: item?.name?.[0]?.text,
                code: `${item?.resourceType}/${item?.id}`,
                data: item,
              };
              optionsArrayGP.push(obj);
            }

            setGeneralPractitionerOptionsList(optionsArrayGP);
            break;

          case 'prov':
            let optionsArray = [];
            for (let item of organizationProvArray) {
              let obj = {
                display:
                  item?.resourceType?.toLowerCase() === 'organization'
                    ? item?.name
                    : item?.name?.[0]?.text,
                code: `${item?.resourceType}/${item?.id}`,
                data: item,
              };
              optionsArray.push(obj);
            }

            setPrimaryCareOptionsList(optionsArray);
            break;
          case 'org':
            let optionsArrayOrg = [];
            for (let item of organizationNotProvAndInsArray) {
              let obj = {
                display: item?.name,
                code: `${item?.resourceType}/${item?.id}`,
                data: item,
              };

              optionsArrayOrg.push(obj);
            }
            setManagingOrganizationOptionsList(optionsArrayOrg);
            break;
          default:
            break;
        }
      }
      setOptionsListRetrieved(true);
    } catch (e) {
      console.error(`fhirPatient->getOrganizationAndPractionerData`, e);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (_.isUndefined(practitionerObject?.id)) {
      reduxDispatch(setEditMode(true));
    }

    dispatch({ type: ACTION_CLOSE_ALL_DRAWER });
    dispatch({ type: ACTION_OPEN_TOOLBAR });

    if (
      _.isEmpty(managingOrganizationOptionsList) &&
      _.isEmpty(primaryCareOptionsList) &&
      _.isEmpty(generalPractitionerOptionsList)
    ) {
      getOrganizationData(['prov', 'gp', 'org']);
    }
  }, []);

  useEffect(() => {
    let mo, mg, mp;
    if (!_.isEmpty(managingOrganizationOptionsList)) {
      // debugger;
      mo =
        managingOrganizationOptionsList?.[
          _.findIndex(
            managingOrganizationOptionsList,
            o => o?.code === practitionerState?.managingOrganizationObject?.code
          )
        ];

      if (!_.isEmpty(primaryCareOptionsList)) {
        // debugger;
        mp =
          primaryCareOptionsList?.[
            _.findIndex(
              primaryCareOptionsList,
              o => o?.code === practitionerState?.primaryCareObject?.code
            )
          ];
      }

      if (!_.isEmpty(generalPractitionerOptionsList)) {
        // debugger;
        mg =
          generalPractitionerOptionsList?.[
            _.findIndex(
              generalPractitionerOptionsList,
              o =>
                o?.code === practitionerState?.generalPractitionerObject?.code
            )
          ];
      }
      setPractitionerState({
        ...practitionerState,
        managingOrganizationObject: mo,
        primaryCareObject: mp,
        generalPractitionerObject: mg,
      });
    }
  }, [optionsListRetrieved, props]);

  // const primaryCareValidationObject = {
  //   name: "primaryCareObject",
  //   value: practitionerState?.primaryCareObject,
  //   label: "Primary Care",
  //   optionsList: primaryCareOptionsList,
  //   ref: primaryCareRef,
  //   validation: {
  //     required: true,
  //   },
  // };

  // const generalPractitionerValidationObject = {
  //   name: "generalPractitionerObject",
  //   value: practitionerState?.generalPractitionerObject,
  //   label: "General Practitioner",
  //   optionsList: generalPractitionerOptionsList,
  //   ref: generalPractitionerRef,
  // };

  const managingOrganizationValidationObject = {
    name: 'managingOrganizationObject',
    value: practitionerState?.managingOrganizationObject,
    label: 'Managing Organization',
    optionsList: managingOrganizationOptionsList,
    ref: managingOrganizationRef,
  };

  const languageValidationObject = {
    name: 'languageObject',
    value: !_.isUndefined(practitionerState?.languageObject?.code)
      ? practitionerState?.languageObject
      : { code: 'en', display: 'English' },
    label: 'Preferred Language',
    optionsList: languageList,
    ref: languageRef,
  };

  const [isIdentityUploadDrawerOpen, setIsIdentityUploadDrawerOpen] =
    useState(false);

  const [isInsuranceUploadDrawerOpen, setIsInsuranceUploadDrawerOpen] =
    useState(false);

  const [isCertificateDrawerOpen, setIsCertificateDrawerOpen] = useState(false);
  const [isLicenseDrawerOpen, setIsLicenseDrawerOpen] = useState(false);

  const [npiSelectedFromRegistry, setNpiSelectedFromRegistry] = useState({
    isSelected: false,
    data: {},
  });

  useEffect(() => {
    props?.handleOnCallback({
      name: 'identityUpload',
      payload: isIdentityUploadDrawerOpen,
    });
  }, [isIdentityUploadDrawerOpen]);
  useEffect(() => {
    props?.handleOnCallback({
      name: 'licenseUpload',
      payload: isLicenseDrawerOpen,
    });
  }, [isLicenseDrawerOpen]);
  useEffect(() => {
    props?.handleOnCallback({
      name: 'certificateUpload',
      payload: isCertificateDrawerOpen,
    });
  }, [isCertificateDrawerOpen]);

  useEffect(() => {
    props?.handleOnCallback({
      name: 'insuranceUpload',
      payload: isInsuranceUploadDrawerOpen,
    });
  }, [isInsuranceUploadDrawerOpen]);

  const [isIdentityExists, setIsIdentityExists] = useState(false);
  const [isInsuranceExists, setIsInsuranceExists] = useState(false);
  const [isCertificateExists, setIsCertificateExists] = useState(false);
  const [isLicenseExists, setIsLicenseExists] = useState(false);

  useEffect(() => {
    practitionerObject?.identifier?.forEach(idf => {
      if (
        idf?.type?.coding?.[0]?.code === 'NI' ||
        idf?.type?.coding?.[0]?.code === 'DL' ||
        idf?.type?.coding?.[0]?.code === 'PPN'
      ) {
        setIsIdentityExists(true);
      }

      if (idf?.type?.coding?.[0]?.code === 'NII') {
        setIsInsuranceExists(true);
      }

      if (idf?.type?.coding?.[0]?.code === 'MD') {
        setIsLicenseExists(true);
      }

      if (idf?.type?.coding?.[0]?.code === 'AC') {
        setIsCertificateExists(true);
      }
    });
  }, [practitionerObject]);

  const [currentNameObject, setCurrentNameObject] = useState(
    !_.isUndefined(
      practitionerState?.name?.[
        _.findIndex(practitionerState?.name, o => o?.use === 'official')
      ]
    )
      ? practitionerState?.name?.[
          _.findIndex(practitionerState?.name, o => o?.use === 'official')
        ]
      : {
          use: '',
          text: '',
          family: '',
          given: [],
          prefix: [],
          suffix: [],
        }
  );

  const [currentAddressObject, setCurrentAddressObject] = useState({
    official: !_.isUndefined(
      practitionerState?.address?.[
        _.findIndex(practitionerState?.address, o => o?.use === 'home')
      ]
    )
      ? practitionerState?.address?.[
          _.findIndex(practitionerState?.address, o => o?.use === 'home')
        ]
      : {
          use: 'home',
          type: 'postal',
          text: '',
          line: [],
          city: '',
          district: '',
          state: '',
          postalCode: '',
          country: '',
        },
    billing: !_.isUndefined(
      practitionerState?.address?.[
        _.findIndex(practitionerState?.address, o => o?.use === 'work')
      ]
    )
      ? practitionerState?.address?.[
          _.findIndex(practitionerState?.address, o => o?.use === 'work')
        ]
      : {
          use: 'work',
          type: 'postal',
          text: '',
          line: [],
          city: '',
          district: '',
          state: '',
          postalCode: '',
          country: '',
        },
  });

  useEffect(() => {
    setCurrentNameObject(
      practitionerState?.name?.[
        _.findIndex(
          practitionerState?.name,
          o => o?.use === currentNameObject?.use
        )
      ]
    );

    setCurrentAddressObject({
      official: !_.isUndefined(
        practitionerState?.address?.[
          _.findIndex(practitionerState?.address, o => o?.use === 'home')
        ]
      )
        ? practitionerState?.address?.[
            _.findIndex(practitionerState?.address, o => o?.use === 'home')
          ]
        : {
            use: 'home',
            type: 'postal',
            text: '',
            line: [],
            city: '',
            district: '',
            state: '',
            postalCode: '',
            country: '',
          },
      billing: !_.isUndefined(
        practitionerState?.address?.[
          _.findIndex(practitionerState?.address, o => o?.use === 'work')
        ]
      )
        ? practitionerState?.address?.[
            _.findIndex(practitionerState?.address, o => o?.use === 'work')
          ]
        : {
            use: 'work',
            type: 'postal',
            text: '',
            line: [],
            city: '',
            district: '',
            state: '',
            postalCode: '',
            country: '',
          },
    });
  }, [practitionerState]);

  useEffect(() => {
    setPractitionerState(practitionerInitailStateFromProps(practitionerObject));
    // if (isMyPractice) {
    if (
      practitionerObject?.qualification &&
      practitionerObject?.qualification.length
    ) {
      let tempLicenses = [];
      practitionerObject?.qualification
        .filter(f => f?.code?.coding[0]?.code === 'SL')
        .forEach(l => {
          if (l?.identifier) {
            tempLicenses.push({
              licenseType: 'None',
              number: JSON.parse(l?.identifier[0]?.value)[0],
              secondary_number: JSON.parse(l?.identifier[0]?.value)[1],
              state: {
                label: l?.extension[0]?.valueString,
                value: l?.extension[0]?.valueString,
              },
            });
          }
        });
      if (
        practitionerObject?.qualification.filter(
          f => f?.code?.coding[0]?.code === 'DEA'
        ).length
      ) {
        setIsECSEnabled('yes');
      }
      practitionerObject?.qualification
        .filter(f => f?.code?.coding[0]?.code === 'DEA')
        .forEach(l => {
          tempLicenses.push({
            licenseType: 'DEA',
            number: l?.identifier[0]?.value,
            secondary_number: '',
            state: '',
          });
        });
      setLicenses([...tempLicenses]);
      setLicensesBackup([...tempLicenses]);
    }
    // }
  }, [practitionerObject]);

  const getGender = gender => {
    if (gender === 'M') return 'male';
    if (gender === 'F') return 'female';
    if (gender === 'O') return 'other';
    if (gender === 'U') return 'unknown';
    return '';
  };

  useEffect(() => {
    if (npiSelectedFromRegistry?.isSelected) {
      const npiData = npiSelectedFromRegistry?.data;
      // console.warn(npiData);
      setPractitionerState({
        ...practitionerState,
        gender: getGender(npiData?.basic?.gender),
        npi: npiData?.number,
      });
    }
  }, [npiSelectedFromRegistry]);

  const handleOnDataCallBack = (from, payload) => {};

  const handleOnChange = event => {
    const { name, value } = event?.target;

    if (name === 'use') {
      if (
        _.isUndefined(
          practitionerState?.name[
            _.findIndex(practitionerState?.name, o => o.use === value)
          ]
        )
      ) {
        setCurrentNameObject({
          [name]: value,
        });
      } else {
        setCurrentNameObject(
          practitionerState?.name[
            _.findIndex(practitionerState?.name, o => o.use === value)
          ]
        );
      }
    } else if (name === 'useAddress') {
      if (
        !_.isUndefined(
          practitionerState?.address[
            _.findIndex(practitionerState?.address, o => o.use === value)
          ]
        )
      ) {
        setCurrentAddressObject(
          practitionerState?.address[
            _.findIndex(practitionerState?.address, o => o.use === value)
          ]
        );
      } else {
        setCurrentAddressObject({
          [name]: value,
        });
      }
    } else {
      setPractitionerState({
        ...practitionerState,
        [name]: value,
      });
    }
  };

  const handleOnCancelClick = () => {
    setIsCreatePatient(false);
  };

  // const handleOnClick = async event => {
  //   const { name } = event?.target;

  //   // debugger;

  //   if (name === 'createRecord' || name === 'fullUpdate') {
  //     let nameObj = humanNameRef?.current?.handleOnUpdate();
  //     let addressList = addressRef?.current?.handleOnUpdate();
  //     let telecomArray = telecomRef?.current?.handleOnUpdate();

  //     let genderObj = genderRef?.current?.onValidate();
  //     let birtDateObject = birthDateRef?.current?.onValidate();
  //     let ssnObject = ssnRef?.current?.onValidate();
  //     let npiObject = npiRef?.current?.onValidate();

  //     // const pcRawObj = primaryCareRef?.current?.onValidate();

  //     if (
  //       nameObj?.valid &&
  //       addressList?.valid &&
  //       telecomArray?.valid &&
  //       ssnObject?.valid &&
  //       npiObject?.valid &&
  //       // birtDateObject?.valid &&
  //       genderObj?.valid
  //       // pcRawObj?.isValid
  //     ) {
  //       delete nameObj.valid;
  //       delete addressList.valid;
  //       delete telecomArray.valid;

  //       let currentPractitioner = !_.isUndefined(event?.practitionerObject)
  //         ? event?.practitionerObject
  //         : practitionerState;
  //       let identifierSSNObj = {
  //         use: 'usual',
  //         type: {
  //           coding: [
  //             {
  //               system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
  //               code: '',
  //               userSelected: false,
  //             },
  //           ],
  //         },
  //         system: 'http://hl7.org/fhir/sid/us-ssn',
  //         value: 0,
  //       };

  //       identifierSSNObj.type.coding[0].code = 'SS';
  //       identifierSSNObj.value = ssnObject?.value;

  //       let identifierNPIObj = {
  //         use: 'usual',
  //         type: {
  //           coding: [
  //             {
  //               system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
  //               code: '',
  //               userSelected: false,
  //             },
  //           ],
  //         },
  //         system: 'http://hl7.org/fhir/sid/us-ssn',
  //         value: 0,
  //       };

  //       identifierNPIObj.type.coding[0].code = 'NPI';
  //       identifierNPIObj.value = npiObject?.value;
  //       // debugger;
  //       let param = {};
  //       param.name = [nameObj];
  //       param.address = addressList;
  //       param.gender = genderObj?.value;
  //       if (birtDateObject?.value) {
  //         param.birthDate = dayjs(birtDateObject?.value).format('YYYY-MM-DD');
  //       }
  //       param.resourceType = 'Practitioner';

  //       if (currentPractitioner?.photo) {
  //         param.photo = currentPractitioner?.photo;
  //       }

  //       param.identifier = [identifierSSNObj, identifierNPIObj];
  //       if (!_.isEmpty(currentPractitioner?.identifier)) {
  //         const filteredIdentifier = currentPractitioner?.identifier?.filter(
  //           o => o?.type?.coding?.[0]?.code !== 'SS'
  //         );

  //         const filteredNPIIdentifier = currentPractitioner?.identifier?.filter(
  //           o => o?.type?.coding?.[0]?.code !== 'NPI'
  //         );
  //         param.identifier = [
  //           ...filteredIdentifier,
  //           ...filteredNPIIdentifier,
  //           identifierSSNObj,
  //           identifierNPIObj,
  //         ];
  //       }

  //       param.telecom = telecomArray;

  //       // const gpRawObj = generalPractitionerRef?.current?.onValidate();
  //       const mpRawObj = managingOrganizationRef?.current?.onValidate();
  //       const activeRawObj = activeRef?.current?.onValidate();
  //       const languageObject = languageRef?.current?.onValidate();

  //       // if (!pcRawObj?.isValid) {
  //       //   return;
  //       // }

  //       let languageCodableConcept = {
  //         coding: [
  //           {
  //             system: 'http://terminology.hl7.org/CodeSystem/designation-usage',
  //             code: languageObject?.value?.code,
  //             display: languageObject?.value?.display,
  //           },
  //         ],
  //         text: languageObject?.value?.display,
  //       };

  //       let communication = [
  //         {
  //           language: languageCodableConcept,
  //           preferred: true,
  //         },
  //       ];

  //       let qualificationObject = {
  //         identifier: [
  //           {
  //             system: 'http://example.org/UniversityIdentifier',
  //             value: '12345',
  //           },
  //         ],
  //         code: {
  //           coding: [
  //             {
  //               system: 'http://terminology.hl7.org/CodeSystem/v2-0360/2.7',
  //               code: 'BS',
  //               display: 'Bachelor of Science',
  //             },
  //           ],
  //           text: 'Bachelor of Science',
  //         },
  //         period: {
  //           start: '1995',
  //         },
  //         issuer: {
  //           display: 'Example University',
  //         },
  //       };

  //       qualificationObject.code.coding[0].code =
  //         practitionerState?.qualificationObject?.code;
  //       qualificationObject.code.coding[0].display =
  //         practitionerState?.qualificationObject?.display;
  //       qualificationObject.code.text =
  //         practitionerState?.qualificationObject?.display;

  //       if (
  //         !_.isEmpty(practitionerState?.qualificationObject?.code) ||
  //         !_.isUndefined(practitionerState?.qualificationObject?.code)
  //       ) {
  //         param.qualification = [qualificationObject];
  //       }
  //       param.active = activeRawObj?.value;

  //       if (!_.isUndefined(mpRawObj?.value?.code)) {
  //         param.managingOrganization = {
  //           reference: mpRawObj?.value?.code,
  //         };
  //       }
  //       //
  //       // if (!_.isEmpty(generalPractitioner)) {
  //       //   param.generalPractitioner = generalPractitioner;
  //       // }

  //       let message = '';
  //       let type = 'info';
  //       let notificationDescription = '';
  //       try {
  //         reduxDispatch(setProgress(true));
  //         let response = null;
  //         if (!_.isUndefined(practitionerState?.id)) {
  //           param.id = practitionerState?.id;
  //           response = await ehrAPIService.put(`updateResource`, param);
  //           message = ` Practitioner Record updated successfully`;
  //           notificationDescription = ` Practitioner Record updated successfully`;
  //         } else {
  //           response = await ehrAPIService.post(`createResource`, param);
  //           message = ` Practitioner Record created successfully`;
  //           notificationDescription = ` Practitioner Record created successfully`;
  //           navigate('/practitioner');
  //         }
  //         type = 'success';
  //         flatObjectFromFhirPractitioner(response?.data).then(pObject => {
  //           reduxDispatch(setReduxCurrentPractitionerObject(pObject));
  //         });
  //         localStorage.setItem('practitionerId', response?.data?.resource?.id);
  //         reduxDispatch(setEditMode(false));
  //       } catch (e) {
  //         console.error(`error_body`, e);
  //         type = 'error';
  //         let errorCode = `Error: ${e?.response?.status}`;
  //         message = `${errorCode}. Reason: ${e?.response?.data?.issue?.[0]?.diagnostics}`;
  //         notificationDescription = 'Something went wrong , please try again.';
  //       } finally {
  //         reduxDispatch(setProgress(false));
  //         generateNotifications({
  //           title: message,
  //           descriptions: notificationDescription,
  //           enqueueSnackbar,
  //           closeSnackbar,
  //           reduxDispatch,
  //         });
  //         /* reduxDispatch(
  //           setSnackbarState({
  //             open: true,
  //             message: message,
  //             type: type,
  //           })
  //         );
  //         reduxDispatch(
  //           setNotificationsList({
  //             descriptions: notificationDescription,
  //           })
  //         ); */
  //       }
  //     }
  //   }
  // };

  const updateRcopiaUser = async (uid, licenses) => {
    // debugger;
    let response = await ehrAPIBaseService.get('auth2/auth/getUser?uid=' + uid);
    if (response?.status === 200 && response?.data?.userId) {
      let payload = structuredClone(response?.data);
      payload = {
        ...payload,
        providerLicenses: {
          ...payload.providerLicenses,
          deaList: licenses
            .filter(f => f.licenseType === 'DEA')
            .map(m => m.number),
          stateLicenseList: licenses
            .filter(f => f.licenseType !== 'DEA')
            .map(license => {
              let licensesObj = {
                state: license?.state?.value,
                primaryLicenseNumber: license?.number,
              };
              // if (license?.secondary_number) {
              if (
                license?.state?.value === 'PR' ||
                license?.state?.value === 'DC'
              ) {
                licensesObj['secondaryLicenseNumber'] =
                  license?.secondary_number;
              }
              return licensesObj;
            }),
        },
      };
      const userUpdateResponse = await ehrAPIBaseService.post(
        `auth2/auth/editUser`,
        payload
      );
      console.log(userUpdateResponse);
    }
  };

  const scrollToFirstInvalid = validationArray => {
    const firstInvalid = validationArray?.find(item => !item?.isValid);

    if (firstInvalid?.ref?.current) {
      firstInvalid?.ref?.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  };

  useImperativeHandle(ref, () => ({
    handleOnSave: async currentPractitionerState => {
      let nameObj = humanNameRef?.current?.handleOnUpdate();
      let addressList = addressRef?.current?.handleOnUpdate();
      let telecomArray = telecomRef?.current?.handleOnUpdate();

      let genderObj = genderRef?.current?.onValidate();
      let birtDateObject = birthDateRef?.current?.onValidate();
      // let ssnObject = ssnRef?.current?.onValidate();

      let validationObject1 = selectedVersion === 'IN' ? aadhaarRef : ssnRef;
      let validationValue1 = validationObject1?.current?.onValidate();

      let qualificationObj = qualificationRef?.current?.onValidate();
      let validationObject2 = selectedVersion === 'IN' ? nmcRef : npiRef;
      let validationValue2 = validationObject2?.current?.onValidate();

      const validationChecks = [
        { isValid: nameObj?.valid, ref: nameRef },
        { isValid: validationValue1?.valid, ref: v1Ref },
        { isValid: validationValue2?.valid, ref: v2Ref },
        { isValid: addressList?.valid, ref: addRef },
        { isValid: telecomArray?.valid, ref: contactRef },
      ];

      // const pcRawObj = primaryCareRef?.current?.onValidate();
      if (
        !(
          isStateChanged ||
          nameObj?.isStateChanged ||
          addressList?.isStateChanged ||
          telecomArray?.isStateChanged
        ) &&
        practitionerState?.id
      ) {
        try {
          const options = {
            message: 'No data changed. Do you still want to save?',
            isDark,
          };
          await confirmation(options);
          //   {
          //   description: (
          //     <DialogContent>
          //       Nothing in the state has changed. Do you still want to save?
          //     </DialogContent>
          //   ),
          //   dialogProps: {
          //     style: {
          //       zIndex: 2000,
          //     },
          //     classes: {
          //       paper: isDark ? 'darkDialogPaper' : 'lightDialogPaper',
          //       color: isDark ? '#fff' : '#222',
          //     },
          //     PaperProps: {
          //       style: {
          //         backgroundColor: isDark ? '#222' : '#fff',
          //         color: isDark ? '#fff' : '#333',
          //       },
          //     },
          //   },
          // });
        } catch (e) {
          return;
        }
      }

      if (
        nameObj?.valid &&
        addressList?.valid &&
        telecomArray?.valid &&
        validationValue1?.valid &&
        validationValue2?.valid
        // birtDateObject?.valid &&
        // birtDateObject?.value !== '' &&
        // genderObj?.valid &&
        // qualificationObj?.isValid
        // pcRawObj?.isValid
      ) {
        delete nameObj.valid;
        delete addressList.valid;
        delete telecomArray.valid;

        delete nameObj.isStateChanged;
        delete addressList.isStateChanged;
        delete telecomArray.isStateChanged;
        // if (props?.isMyPractice) {
        if (!licenses.filter(f => f.licenseType === 'None').length) {
          generateNotifications({
            title: 'Please add one or more licenses.',
            descriptions: 'Please add one or more licenses.',
            enqueueSnackbar,
            closeSnackbar,
            reduxDispatch,
          });
          return false;
        }
        if (
          isECSEnabled === 'yes' &&
          !licenses.filter(f => f.licenseType === 'DEA').length
        ) {
          generateNotifications({
            title: 'Please add one or more DEA licenses.',
            descriptions: 'Please add one or more DEA licenses.',
            enqueueSnackbar,
            closeSnackbar,
            reduxDispatch,
          });
          return false;
        }
        // }

        // let currentPractitioner = !_.isUndefined(event?.practitionerObject) ? event?.practitionerObject : practitionerState
        let currentPractitioner = currentPractitionerState;
        let identifierObj1 = {
          use: 'usual',
          type: {
            coding: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
                code: '',
                userSelected: false,
              },
            ],
          },
          system: '',
          value: 0,
        };

        if (selectedVersion === 'IN') {
          identifierObj1.type.coding[0].code = 'AADHAAR';
          identifierObj1.system = 'http://hl7.org/fhir/sid/us-ssn';
          identifierObj1.value = validationValue1?.value;
        } else {
          identifierObj1.type.coding[0].code = 'SS';
          identifierObj1.system = 'http://hl7.org/fhir/sid/us-ssn';
          identifierObj1.value = validationValue1?.value;
        }

        let identifierObj2 = {
          use: 'usual',
          type: {
            coding: [
              {
                system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
                code: '',
                userSelected: false,
              },
            ],
          },
          system: '',
          value: 0,
        };
        if (selectedVersion === 'IN') {
          identifierObj2.type.coding[0].code = 'NMC';
          identifierObj2.system = 'http://hl7.org/fhir/sid/us-ssn';
          identifierObj2.value = validationValue2?.value;
        } else {
          identifierObj2.type.coding[0].code = 'NPI';
          identifierObj2.system = 'http://hl7.org/fhir/sid/us-ssn';
          identifierObj2.value = validationValue2?.value;
        }
        // let identifierObj = {
        //   use: "usual",
        //   type: {
        //     coding: [
        //       {
        //         system: "http://terminology.hl7.org/CodeSystem/v2-0203",
        //         code: "",
        //         userSelected: false,
        //       },
        //     ],
        //   },
        //   system: "http://hl7.org/fhir/sid/us-ssn",
        //   value: 0,
        // };

        // identifierObj.type.coding[0].code = "SS";
        // identifierObj.value = ssnObject?.value;
        // debugger;
        let param = {};
        debugger;
        param.name = [nameObj];

        if (nameObj.given?.length > 0) {
          const firstName = nameObj.given[0];
          const capitalizedFirstName = firstName
            ? firstName.charAt(0).toUpperCase() + firstName.slice(1)
            : '';
          param.name[0].given[0] = capitalizedFirstName;
        }

        if (nameObj.given?.length > 0) {
          const lastName = nameObj.given[2];
          const capitalizedlastName = lastName
            ? lastName.charAt(0).toUpperCase() + lastName.slice(1)
            : '';
          param.name[0].given[2] = capitalizedlastName;
        }

        if (nameObj.given?.length > 1) {
          const middleName = nameObj.given[1];
          const capitalizedMiddleName = middleName
            ? middleName.charAt(0).toUpperCase() + middleName.slice(1)
            : '';
          param.name[0].given[1] = capitalizedMiddleName;
        }

        if (nameObj.family) {
          debugger;
          const lastName = nameObj.family;
          const capitalizedLastName = lastName
            ? lastName.charAt(0).toUpperCase() + lastName.slice(1)
            : '';
          param.name[0].family = capitalizedLastName;
        }

        if (addressList.length === 2) {
          if (
            addressList[0].city !== addressList[1].city ||
            addressList[0].state !== addressList[1].state ||
            addressList[0].line[0] !== addressList[1].line[0]
          ) {
            param.address = addressList;
          } else {
            // Remove the element with addressList[x].use = "work"
            const homeAddress = addressList.find(
              address => address.use === 'home'
            );
            addressList = [homeAddress].filter(address => !!address);
            param.address = addressList;
          }
        } else {
          param.address = addressList;
        }

        param.gender = genderObj?.value;
        if (birtDateObject?.value) {
          param.birthDate = moment(birtDateObject?.value).format('yyyy-MM-DD');
        }
        param.resourceType = 'Practitioner';

        if (currentPractitioner?.fullRawData?.photo) {
          param.photo = currentPractitioner?.fullRawData?.photo;
        }

        // param.identifier = [identifierObj];
        // if (!_.isEmpty(currentPractitioner?.fullRawData?.identifier)) {
        //   const filteredIdentifier =
        //     currentPractitioner?.fullRawData?.identifier?.filter(
        //       (o) => o?.type?.coding?.[0]?.code !== "SS"
        //     );
        //   param.identifier = [...filteredIdentifier, identifierObj];
        // }

        param.identifier = [identifierObj1, identifierObj2];
        if (!_.isEmpty(currentPractitioner?.fullRawData?.identifier)) {
          let otherfilteredIdentifier;

          if (selectedVersion === 'IN') {
            otherfilteredIdentifier =
              currentPractitioner?.fullRawData?.identifier
                ?.filter(o => o?.type?.coding?.[0]?.code !== 'AADHAAR')
                ?.filter(o => o?.type?.coding?.[0]?.code !== 'NMC');
          } else {
            otherfilteredIdentifier =
              currentPractitioner?.fullRawData?.identifier
                ?.filter(o => o?.type?.coding?.[0]?.code !== 'SS')
                ?.filter(o => o?.type?.coding?.[0]?.code !== 'NPI');
          }

          // const filteredNPIIdentifier = currentPractitioner?.identifier?.filter(
          //   (o) => o?.type?.coding?.[0]?.code !== "NPI"
          // );

          param.identifier = [
            ...otherfilteredIdentifier,
            // ...filteredIdentifier,
            // ...filteredNPIIdentifier,
            identifierObj1,
            identifierObj2,
          ];
        }

        param.telecom = telecomArray;

        // const gpRawObj = generalPractitionerRef?.current?.onValidate();
        const mpRawObj = managingOrganizationRef?.current?.onValidate();
        const activeRawObj = activeRef?.current?.onValidate();
        const languageObject = languageRef?.current?.onValidate();

        // if (!pcRawObj?.isValid) {
        //   return;
        // }

        let languageCodableConcept = {
          coding: [
            {
              system: 'http://terminology.hl7.org/CodeSystem/designation-usage',
              code: languageObject?.value?.code,
              display: languageObject?.value?.display,
            },
          ],
          text: languageObject?.value?.display,
        };

        let communication = [languageCodableConcept];

        let qualificationObject = [];
        if (qualificationObj?.value?.code) {
          qualificationObject.push({
            code: {
              coding: [
                {
                  system: 'http://terminology.hl7.org/CodeSystem/v2-0360/2.7',
                  code: qualificationObj?.value?.code,
                  display: qualificationObj?.value?.display,
                },
              ],
              text: qualificationObj?.value?.display,
            },
            period: {
              start: '1995',
            },
            issuer: {
              display: 'Example University',
            },
          });
        }
        // if (isMyPractice) {
        if (licenses.filter(f => f.licenseType !== 'DEA').length) {
          licenses
            .filter(f => f.licenseType !== 'DEA')
            .forEach(license => {
              qualificationObject.push({
                code: {
                  coding: [
                    {
                      system: 'http://terminology.hl7.org/CodeSystem/v2-0203',
                      code: 'SL',
                      display: 'State License Number',
                    },
                  ],
                  text: 'State License Number',
                },
                identifier: [
                  {
                    system: 'http://example.com/identifier/state-license',
                    value: JSON.stringify([
                      license?.number,
                      license?.secondary_number,
                    ]),
                  },
                ],
                extension: [
                  {
                    url: 'http://example.com/extension/state',
                    valueString: license?.state?.value,
                  },
                ],
              });
            });
        }
        if (licenses.filter(f => f.licenseType === 'DEA').length) {
          licenses
            .filter(f => f.licenseType === 'DEA')
            .map(license => {
              qualificationObject.push({
                code: {
                  coding: [
                    {
                      system: 'http://example.com/identifier/dea-license',
                      code: 'DEA',
                      display: 'DEA',
                    },
                  ],
                  text: 'DEA',
                },
                identifier: [
                  {
                    system: 'http://example.com/identifier/dea-license',
                    value: license?.number,
                  },
                ],
                issuer: {
                  display: 'DEA',
                },
              });
            });
        }
        // }

        // qualificationObject.code.coding[0].code = practitionerState?.qualificationObject?.code
        // qualificationObject.code.coding[0].display = practitionerState?.qualificationObject?.display
        // qualificationObject.code.text = practitionerState?.qualificationObject?.display

        // qualificationObject.code.coding[0].code = qualificationObj?.value?.code;
        // qualificationObject.code.coding[0].display =
        //   qualificationObj?.value?.display;
        // qualificationObject.code.text = qualificationObj?.value?.display;

        // if (
        //   !_.isEmpty(practitionerState?.qualificationObject?.code) ||
        //   !_.isUndefined(practitionerState?.qualificationObject?.code)
        // ) {
        // }
        param.qualification = qualificationObject;
        param.active = activeRawObj?.value;
        param.communication = communication;

        // let generalPractitioner = [];

        // if (!_.isUndefined(pcRawObj?.value?.code)) {
        //   generalPractitioner.push({
        //     reference: pcRawObj?.value?.code,
        //   });
        // }

        // if (!_.isUndefined(gpRawObj?.value?.code)) {
        //   generalPractitioner.push({
        //     reference: gpRawObj?.value?.code,
        //   });
        // }

        // if (
        //   _.isUndefined(pcRawObj?.value?.code) &&
        //   _.isUndefined(gpRawObj?.value?.code)
        // ) {
        //   generalPractitioner = [];
        // }

        // let practitionerRoleSkeleton = {
        //   resourceType: "PractitionerRole",
        //   id: "",
        //   text: {
        //     status: "generated",
        //     div: '<div xmlns="http://www.w3.org/1999/xhtml">\n\t\t\t<p>\n\t\t\t\tDr Adam Careful is a Referring Practitioner for Acme Hospital from 1-Jan 2012 to 31-Mar\n\t\t\t\t2012\n\t\t\t</p>\n\t\t</div>',
        //   },
        //   identifier: [
        //     {
        //       system: "http://www.acme.org/practitioners",
        //       value: "23",
        //     },
        //   ],
        //   active: true,
        //   period: {
        //     start: "2012-01-01",
        //     end: "2012-03-31",
        //   },
        //   practitioner: {
        //     reference: "Practitioner/example",
        //     display: "Dr Adam Careful",
        //   },
        //   organization: {
        //     reference: "Organization/f001",
        //   },
        //   code: [
        //     {
        //       coding: [
        //         {
        //           system: "http://terminology.hl7.org/CodeSystem/v2-0286",
        //           code: "RP",
        //         },
        //       ],
        //     },
        //   ],
        //   specialty: [
        //     {
        //       coding: [
        //         {
        //           system: "http://snomed.info/sct",
        //           code: "408443003",
        //           display: "General medical practice",
        //         },
        //       ],
        //     },
        //   ],
        //   location: [
        //     {
        //       reference: "Location/1",
        //       display: "South Wing, second floor",
        //     },
        //   ],
        //   healthcareService: [
        //     {
        //       reference: "HealthcareService/example",
        //     },
        //   ],
        //   contact: [
        //     {
        //       telecom: [
        //         {
        //           system: "phone",
        //           value: "(03) 5555 6473",
        //           use: "work",
        //         },
        //         {
        //           system: "email",
        //           value: "adam.southern@example.org",
        //           use: "work",
        //         },
        //       ],
        //     },
        //   ],
        //   availability: [
        //     {
        //       availableTime: [
        //         {
        //           daysOfWeek: ["mon", "tue", "wed"],
        //           availableStartTime: "09:00:00",
        //           availableEndTime: "16:30:00",
        //         },
        //         {
        //           daysOfWeek: ["thu", "fri"],
        //           availableStartTime: "09:00:00",
        //           availableEndTime: "12:00:00",
        //         },
        //       ],
        //       notAvailableTime: [
        //         {
        //           description: "Adam will be on extended leave during May 2017",
        //           during: {
        //             start: "2017-05-01",
        //             end: "2017-05-20",
        //           },
        //         },
        //         {
        //           description:
        //             "Adam is generally unavailable on public holidays and during the Christmas/New Year break",
        //         },
        //       ],
        //     },
        //   ],
        //   endpoint: [
        //     {
        //       reference: "Endpoint/example",
        //     },
        //   ],
        // };

        if (!_.isUndefined(mpRawObj?.value?.code)) {
          // param.managingOrganization = {
          //   reference: mpRawObj?.value?.code,
          // };
        }
        //
        // if (!_.isEmpty(generalPractitioner)) {
        //   param.generalPractitioner = generalPractitioner;
        // }

        let message = '';
        let type = 'info';
        let notificationDescription = '';
        try {
          reduxDispatch(setProgress(true));
          let response = null;
          if (!_.isUndefined(practitionerState?.id)) {
            param.id = practitionerState?.id;
            debugger;
            // param.name=practitionerState?.name;
            response = await ehrAPIService.put(`updateResource`, param);
            message = `Practitioner Updated Successfully`;
            notificationDescription = `Practitioner Updated Successfully`;
          } else {
            reduxDispatch(resetStateDetectorState());
            response = await ehrAPIService.post(`createResource`, param);
            message = `Practitioner Created Successfully`;
            notificationDescription = ` Practitioner Created Successfully`;
            navigate(`/practitioner/record/${response?.data?.id}`, {
              state: {
                practitionerObject: response.data,
              },
            });
          }
          if (param?.identifier.filter(f => f?.system === 'user_uid').length) {
            if (!isEqual(licenses, licensesBackup)) {
              await updateRcopiaUser(
                param?.identifier.find(f => f?.system === 'user_uid')?.value,
                licenses
              );
            }
          }
          type = 'success';
          flatObjectFromFhirPractitioner(response?.data).then(pObject => {
            reduxDispatch(setReduxCurrentPractitionerObject(pObject));
          });
          localStorage.setItem('practitionerId', response?.data?.resource?.id);
          reduxDispatch(setEditMode(false));
        } catch (e) {
          console.error(`error_body`, e);
          type = 'error';
          let errorCode = `Error: ${e?.response?.status}`;
          message = `${errorCode}. Reason: ${e?.response?.data?.issue?.[0]?.diagnostics}`;
        } finally {
          reduxDispatch(setProgress(false));
          generateNotifications({
            title: message,
            descriptions: notificationDescription,
            enqueueSnackbar,
            closeSnackbar,
            reduxDispatch,
          });
          /* reduxDispatch(
            setSnackbarState({
              open: true,
              message: message,
              type: type,
            })
          );
          reduxDispatch(
            setNotificationsList({
              descriptions: notificationDescription,
            })
          ); */
        }
      } else {
        scrollToFirstInvalid(validationChecks);
      }
      // }
    },
  }));

  const openNPIRegistry = () => {
    dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
    dispatch({ type: ACTION_RIGHT_DRAWER });
    dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
    dispatch({
      type: ACTION_RIGHT_DRAWER_JSX,
      payload: <NPIRegistryDrawer setNPI={setNpiSelectedFromRegistry} />,
    });
  };

  const Required = () => <span style={{ color: 'red' }}>*</span>;

  const openDrawer = () => {
    dispatch({ type: ACTION_RIGHT_DRAWER_NOT });
    dispatch({ type: ACTION_RIGHT_DRAWER });
    dispatch({ type: ACTION_OPEN_RIGHT_FLOATING_DRAWER });
  };

  const showLicenseDrawer = (isDEA = false) => {
    openDrawer();
    dispatch({
      type: ACTION_RIGHT_DRAWER_JSX,
      payload: (
        <AddLicenseDrawer
          licenses={licenses}
          setLicenses={setLicenses}
          setValue={() => {}}
          isDEA={isDEA}
        />
      ),
    });
  };

  const editLicenseRecord = (e, idx) => {
    let tempLicenses = structuredClone(licenses);
    if (tempLicenses.length > idx) {
      tempLicenses[idx][e.target.name] = e.target.value;
    }
    setLicenses([...tempLicenses]);
  };

  const removeLicense = (license, idx) => {
    const options = {
      message: 'Are you sure you want to delete the license?',
      isDark,
    };
    confirmation(options)
      // {
      // description: (
      //   <DialogContent>
      //     Are you sure you want to delete the license?
      //   </DialogContent>
      // ),

      // title: 'Confirmation',
      // description: `Are you sure want to delete the license?`,
      // })
      .then(() => {
        removeLicenceOnConfirmation(idx);
      })
      .catch(e => {
        console.log(e);
      });
    // let tempLicenses = [...licenses]
    // tempLicenses.splice(idx, 1)
    // setValue('licenses', tempLicenses)
    // setLicenses([...tempLicenses])
    // add useConfirm here
  };

  const removeLicenceOnConfirmation = number => {
    let tempLicenses = licenses.filter(license => license.number !== number);
    setLicenses(tempLicenses);
  };

  const titleSection = (
    <>
      <Grid
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
        item
        xs={12}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            sx={{
              color: 'bodyHeadingColor',
            }}
            variant="h5"
          >
            Practitioner Information{' '}
            <span
              style={{
                fontStyle: 'italic',
              }}
            >
              {!_.isUndefined(practitionerState?.id) ? (
                <Tooltip title={`${practitionerState?.id}`}>
                  <i variant="h6">{` (Practitioner Id ${practitionerState?.id.substr(
                    0,
                    4
                  )}...)`}</i>
                </Tooltip>
              ) : (
                ''
              )}
            </span>
          </Typography>
          {_.isUndefined(practitionerState?.id) ? (
            selectedVersion === 'IN' ? (
              <></>
            ) : (
              <Link to="" className="pointer" onClick={openNPIRegistry}>
                Search data from NPI Registry
              </Link>
            )
          ) : (
            <></>
          )}
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {_.isUndefined(practitionerState?.id) && editMode && (
              <Button name="createRecord" onClick={handleOnClick}>
                Create
              </Button>
            )}
            {!_.isUndefined(practitionerState?.id) && editMode && (
              <Button name="createRecord" onClick={handleOnClick}>
                Update
              </Button>
            )}
          </Box> */}
        </Box>
        <Divider />
      </Grid>
    </>
  );

  const licenseJSX = (
    <>
      <Grid item xs={12} sx={{ padding: '10px 0' }}>
        <label
          className={`${isDark ? 'sub-heading2-white' : 'sub-heading2'} f-400`}
        >
          {/* EPCS Enabled {isMyPractice ? <Required /> : <></>} */}
          EPCS Enabled {<Required />}
        </label>
        <RadioGroup
          row
          name="row-radio-buttons-group"
          value={isECSEnabled}
          onChange={(e, value) => {
            let tempLicenses = licenses.filter(f => f.licenseType !== 'DEA');
            setLicenses(tempLicenses);
            setIsECSEnabled(value);
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: 'small',
          }}
        >
          <FormControlLabel
            value="yes"
            control={<Radio size="small" fontSize="small" />}
            label="Yes"
          />
          <FormControlLabel
            value="no"
            control={<Radio size="small" fontSize="small" />}
            label="No"
          />
        </RadioGroup>
        <i className="fs-sm">
          DEA number is required if the provider will prescribe controlled
          substances.
        </i>
      </Grid>
      <Grid container style={{ padding: '5px 0' }} columnSpacing={1}>
        <Grid item xs={12}>
          {/* <p>Licenses: {isMyPractice ? <Required /> : <></>}</p> */}
          <p>Licenses: {<Required />}</p>
          <IconButton
            fontSize="small"
            className="text-primary"
            onClick={() => showLicenseDrawer(false)}
          >
            <AddCircleOutlineIcon />
          </IconButton>
          <span className="text-primary">Add State License</span>
        </Grid>
        <Grid item xs={12}>
          <table
            className={isDark ? 'darkmode-enliv-table-2' : 'enliv-table-2'}
          >
            <thead>
              <tr>
                <th>S.No.</th>
                <th>State</th>
                {/* <th style={{ width: '10%', color: isDark && 'white' }}>License Type</th> */}
                <th>Number</th>
                <th>&ensp;</th>
              </tr>
            </thead>
            <tbody>
              {!licenses.filter(f => f.licenseType !== 'DEA').length && (
                <>
                  <tr>
                    <td colSpan={4}>No records to show</td>
                  </tr>
                </>
              )}
              {licenses
                ?.filter(f => f.licenseType !== 'DEA')
                ?.map((license, idx) => {
                  return (
                    <>
                      {license?.licenseType !== 'DEA' ? (
                        <tr
                          key={`license_${idx}`}
                          style={{ padding: '15px 20px' }}
                        >
                          <td>{idx + 1}</td>
                          <td>{license?.state?.value}</td>
                          {/* <td
                                      style={{
                                        backgroundColor: isDark && '#2e3740',
                                      }}
                                    >
                                      {license.licenseType === 'None'
                                        ? `${license?.state?.value} State Lic #`
                                        : license?.licenseType}
                                    </td> */}
                          <td>
                            <TextField
                              size="small"
                              name="number"
                              sx={{
                                margin: '12px 1px',
                                pointerEvents: 'none',
                              }}
                              value={license.number}
                              label="Primary License Number"
                              onChange={e => {
                                editLicenseRecord(e, idx);
                              }}
                            />
                            {(license?.state?.value === 'PR' ||
                              license?.state?.value === 'DC') && (
                              <TextField
                                size="small"
                                name="secondary_number"
                                sx={{
                                  margin: '12px 1px',
                                  pointerEvents: 'none',
                                }}
                                label="Secondary License Number"
                                value={license.secondary_number}
                                onChange={e => {
                                  editLicenseRecord(e, idx);
                                }}
                              />
                            )}
                          </td>
                          <td>
                            <IconButton>
                              <Delete
                                onClick={() =>
                                  removeLicense(licenses, license?.number)
                                }
                                fontSize="small"
                              />
                            </IconButton>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })}
            </tbody>
          </table>
        </Grid>
      </Grid>

      {isECSEnabled === 'yes' && (
        <Grid
          container
          // style={{ padding: '5px 0' }}
          columnSpacing={1}
        >
          <Grid item xs={12}>
            <IconButton
              fontSize="small"
              className="text-primary"
              onClick={() => showLicenseDrawer(true)}
            >
              <AddCircleOutlineIcon />
            </IconButton>
            <span className="text-primary">Add DEA License</span>
          </Grid>
          <Grid item xs={12}>
            <table
              className={isDark ? 'darkmode-enliv-table-2' : 'enliv-table-2'}
            >
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>License Type</th>
                  <th>Number</th>
                  <th>&ensp;</th>
                </tr>
              </thead>
              <tbody>
                {!licenses.filter(f => f.licenseType === 'DEA').length && (
                  <>
                    <tr>
                      <td colSpan={4}>No records to show</td>
                    </tr>
                  </>
                )}
                {licenses
                  ?.filter(f => f.licenseType === 'DEA')
                  ?.map((license, idx) => {
                    return (
                      <>
                        {license?.licenseType === 'DEA' ? (
                          <tr
                            key={`license_${idx}`}
                            style={{
                              padding: '15px 20px',
                            }}
                          >
                            <td>{idx + 1}</td>
                            <td>
                              {license.licenseType === 'None'
                                ? `${license?.state?.value} State Lic #`
                                : license?.licenseType}
                            </td>
                            <td>
                              <TextField
                                size="small"
                                name="number"
                                sx={{
                                  margin: '12px 1px',
                                  pointerEvents: 'none',
                                }}
                                value={license.number}
                                label="Primary License Number"
                                onChange={e => {
                                  editLicenseRecord(e, idx);
                                }}
                              />
                              {(license?.state?.value === 'PR' ||
                                license?.state?.value === 'DC') && (
                                <TextField
                                  size="small"
                                  name="secondary_number"
                                  sx={{
                                    margin: '12px 1px',
                                    pointerEvents: 'none',
                                  }}
                                  label="Secondary License Number"
                                  value={license.secondary_number}
                                  onChange={e => {
                                    editLicenseRecord(e, idx);
                                  }}
                                />
                              )}
                            </td>
                            <td>
                              <IconButton>
                                <Delete
                                  onClick={() =>
                                    removeLicense(licenses, license?.number)
                                  }
                                  fontSize="small"
                                />
                              </IconButton>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  })}
              </tbody>
            </table>
          </Grid>
        </Grid>
      )}
    </>
  );

  const newLeftSection = (
    <>
      <Grid container sx={{ border: '0px solid black' }} item md={8}>
        <Grid ref={nameRef} item xs={12}>
          <FHIRHumanName
            ref={humanNameRef}
            onDataCallback={handleOnDataCallBack}
            isCreate={_.isUndefined(practitionerState?.id)}
            isEdit={isEdit}
            nameObject={currentNameObject}
            npiData={npiSelectedFromRegistry}
          />
        </Grid>
        <Grid item xs={12} container spacing={1}>
          <Grid item sm={4}>
            <DateSelectorWithTopLabelComponent
              onChange={handleOnChange}
              {...birthDateValidationObject}
            />
          </Grid>
          <Grid item sm={4}>
            <SelectWithTopLabelComponent
              onChange={handleOnChange}
              {...genderValidationObject}
            />
          </Grid>
          <Grid ref={v1Ref} item sm={4}>
            <TextFieldWithTopLabelComponent
              onChange={handleOnChange}
              {...ValidationObject1(practitionerState, selectedVersion)}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={1} xs={12} my={2}>
          <Grid ref={v2Ref} item sm={4}>
            <TextFieldWithTopLabelComponent
              onChange={handleOnChange}
              {...ValidationObject2(practitionerState, selectedVersion)}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <Grid spacing={1} container item xs={12}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <AddCircle />
              <Typography>Qualifications</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <AutoCompleteWithTopLabel
              {...qualificationValidationObject}
              onChange={handleOnChange}
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <Grid ref={addRef} item xs={12}>
          <FHIRAddress
            ref={addressRef}
            isEdit={isEdit}
            isCreate={isCreate}
            addressObject={currentAddressObject}
            npiData={npiSelectedFromRegistry}
          />
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <Grid ref={contactRef} item xs={12}>
          <FHIRTelecom
            telecomArray={practitionerState?.telecom}
            ref={telecomRef}
            isEdit={isEdit}
            npiData={npiSelectedFromRegistry}
          />
        </Grid>
        {selectedVersion == 'US' && licenseJSX}
      </Grid>
    </>
  );

  const newRightSection = (
    <Grid
      sx={{
        border: '0px solid black',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
      item
      md={3}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          sx={{ color: 'textFieldColor' }}
          disabled={!isIdentityExists || !practitionerState?.id}
          checked={isIdentityExists}
        />
        <Typography
          onClick={() => {
            if (practitionerState?.id) {
              props?.handleOnCallback({
                name: 'identityUpload',
                payload: true,
              });
            }
          }}
          sx={{
            color: practitionerState?.id ? 'inherit' : 'gray',
            cursor: practitionerState?.id ? 'pointer' : 'default',
            textDecoration: 'underline',
          }}
        >
          <u>Upload Identity Document</u>
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          // disabled={_.isUndefined(practitionerState?.id) || !isEdit ? true : false}
          disabled={!isLicenseExists || !practitionerState?.id}
          checked={isLicenseExists}
          sx={{ color: 'textFieldColor' }}
        />
        <Typography
          sx={{
            color: practitionerState?.id ? 'inherit' : 'gray',
            cursor: practitionerState?.id ? 'pointer' : 'default',
            textDecoration: 'underline',
          }}
          onClick={() => {
            if (practitionerState?.id) {
              props?.handleOnCallback({
                name: 'licenseUpload',
                payload: true,
              });
            }
            // setIsLicenseDrawerOpen(!isLicenseDrawerOpen);
          }}
        >
          <u>Upload License Identification</u>
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Checkbox
          // disabled={_.isUndefined(practitionerState?.id) || !isEdit ? true : false}
          disabled={!isCertificateExists || !practitionerState?.id}
          checked={isCertificateExists}
          sx={{ color: 'textFieldColor' }}
        />
        <Typography
          sx={{
            color: practitionerState?.id ? 'inherit' : 'gray',
            cursor: practitionerState?.id ? 'pointer' : 'default',
            textDecoration: 'underline',
          }}
          onClick={() => {
            if (practitionerState?.id) {
              props?.handleOnCallback({
                name: 'certificateUpload',
                payload: true,
              });
            }
            // setIsCertificateDrawerOpen(!isCertificateDrawerOpen);
          }}
        >
          <u>Upload Certifications</u>
        </Typography>
      </Box>

      <SelectWithTopLabelComponent
        {...activeValidationObject}
        onChange={handleOnChange}
      />

      {isEdit ? (
        <AutoCompleteWithTopLabel
          onChange={handleOnChange}
          {...languageValidationObject}
        />
      ) : (
        paperWithTopLabelAndBottomValue({
          label: 'Language',
          value: practitionerState?.languageObject?.display,
        })
      )}
    </Grid>
  );

  return (
    <>
      <Prompt
        when={isPatientStateChanged}
        message="Unsaved changes detected, continue?"
        beforeUnload={isPatientStateChanged}
      />
      <Grid container spacing={2} style={{ padding: '10px 10px 25px 10px' }}>
        {titleSection}
        {newLeftSection}
        <Grid item sm={1}></Grid>
        {newRightSection}
      </Grid>
    </>
  );
});

export default FHIRPractitioner;
